
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40.378 40.378"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.189 0a20.189 20.189 0 1020.189 20.189A20.185 20.185 0 0020.189 0zm0 36.47A16.281 16.281 0 1136.47 20.189 16.3 16.3 0 0120.189 36.47zm-6.513-17.584a2.605 2.605 0 10-2.605-2.605 2.6 2.6 0 002.605 2.605zm13.025 0a2.605 2.605 0 10-2.601-2.605 2.6 2.6 0 002.6 2.605zm.326 5.91a8.893 8.893 0 01-13.676 0 1.954 1.954 0 10-3 2.5 12.815 12.815 0 0019.684 0 1.954 1.954 0 10-3-2.5z","fill":"#3d9ed3"}})])
          )
        }
      }
    